export enum PriceRateAdditionPricingType {
  Time = "Time",
  Distance = "Distance",
}
